import type { ComponentProps } from 'react';

import { PauseIcon, PlayIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { useMedia } from '..';

export function PlayStopButton(playStopButtonProps: ComponentProps<typeof Button>) {
  const { onClick, ...props } = playStopButtonProps;
  const { isPlaying, togglePlay } = useMedia();

  return (
    <Button
      size={'sm'}
      type={'button'}
      variant={'tertiary'}
      onClick={(e) => {
        e.stopPropagation();
        togglePlay();
        onClick?.(e);
      }}
      {...props}
    >
      {isPlaying ? <PauseIcon /> : <PlayIcon className={'ml-0.5'} />}
    </Button>
  );
}
